(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3793],{

/***/ 96276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(11720));
const footer_styles_1 = __webpack_require__(20223);
const building_blocks_ui_acko_analytics_1 = __webpack_require__(94262);
const footerIcons_1 = __webpack_require__(24621);
const r2d2_1 = __webpack_require__(2758);
const AckoDownloadApp = ({ requestUrl, isMobile }) => {
    const isApp = (0, r2d2_1.cookie)("webview");
    if (isApp) {
        return null;
    }
    const eventMappingObj = {
        download_android_app_cta_clicked: {
            eventName: "tap_footer_download_android_app_cta",
            store: "android",
        },
        download_ios_app_cta_clicked: {
            eventName: "tap_footer_download_ios_app_cta",
            store: "ios",
        },
    };
    const handleStoreDownloadClick = (0, react_1.useCallback)((event, link, ekind) => {
        var _a;
        event.preventDefault();
        Promise
            .allSettled([
            // r2d2 and segment call
            (0, r2d2_1.r2d2)({
                ekind: ekind,
                okind: typeof r2d2_1.cookieWithVal !== "undefined" && (0, r2d2_1.cookieWithVal)("user_id")
                    ? "myaccount_homepage"
                    : "tracker",
                oid: (0, r2d2_1.cookieWithVal)("trackerid"),
            }, requestUrl),
            (0, building_blocks_ui_acko_analytics_1.trackEvent)((_a = eventMappingObj[ekind]) === null || _a === void 0 ? void 0 : _a.eventName, {
                platform: isMobile ? "mweb" : "web"
            })
        ])
            .then(() => {
            window.open(link, "_blank");
        });
    }, []);
    return (react_1.default.createElement(footer_styles_1.DownloadContainer, { isDesktop: !isMobile },
        react_1.default.createElement(footer_styles_1.DownloadHeading, null, "Download our ACKO app now!"),
        react_1.default.createElement(footer_styles_1.AppStoreContainer, { justifyContent: 'center' },
            react_1.default.createElement(footer_styles_1.GooglePlayLink, { target: "_blank", href: "https://ackogi01.onelink.me/j0xF/fce251b8", rel: "noopener", onClick: (event) => {
                    handleStoreDownloadClick(event, "https://ackogi01.onelink.me/j0xF/fce251b8", "download_android_app_cta_clicked");
                } },
                react_1.default.createElement("span", { className: footer_styles_1.StoreImageLink },
                    react_1.default.createElement("img", { src: footerIcons_1.GooglePlay, alt: "Footer Google Play Store" }))),
            react_1.default.createElement(footer_styles_1.AppleStoreLink, { target: "_blank", href: "https://ackogi02.onelink.me/mnNt/d3aba770", rel: "noopener", onClick: (event) => {
                    handleStoreDownloadClick(event, "https://ackogi02.onelink.me/mnNt/d3aba770", "download_ios_app_cta_clicked");
                } },
                react_1.default.createElement("span", { className: footer_styles_1.StoreImageLink },
                    react_1.default.createElement("img", { src: footerIcons_1.AppStore, alt: "Footer Apple Play Store" }))))));
};
exports["default"] = AckoDownloadApp;
//# sourceMappingURL=acko-download-app.js.map

/***/ }),

/***/ 17447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(11720));
const footer_styles_1 = __webpack_require__(20223);
const footer_social_links_1 = __importDefault(__webpack_require__(80598));
const AckoInfo = ({ infoWording }) => {
    var _a, _b;
    return (react_1.default.createElement(footer_styles_1.AckoInfoWrapper, null,
        react_1.default.createElement(footer_styles_1.Heading, null, infoWording === null || infoWording === void 0 ? void 0 : infoWording.heading),
        react_1.default.createElement(footer_styles_1.HeadingItem, null, infoWording === null || infoWording === void 0 ? void 0 : infoWording.headingItem),
        (infoWording === null || infoWording === void 0 ? void 0 : infoWording.showSocialLinks) ? react_1.default.createElement(footer_social_links_1.default, null) : null,
        (infoWording === null || infoWording === void 0 ? void 0 : infoWording.groupCompanies) ?
            react_1.default.createElement(footer_styles_1.GroupCompanies, null,
                react_1.default.createElement(footer_styles_1.GroupCompanyHeading, null, (_a = infoWording === null || infoWording === void 0 ? void 0 : infoWording.groupCompanies) === null || _a === void 0 ? void 0 : _a.title),
                react_1.default.createElement(footer_styles_1.GroupCompanyUlTag, null, (_b = infoWording === null || infoWording === void 0 ? void 0 : infoWording.groupCompanies) === null || _b === void 0 ? void 0 : _b.lists.map((item, index) => (react_1.default.createElement(footer_styles_1.GroupCompanyLiTag, { key: `${item === null || item === void 0 ? void 0 : item.url}${index}` },
                    react_1.default.createElement(footer_styles_1.GroupCompanyAnchorTag, { href: item === null || item === void 0 ? void 0 : item.url, onClick: (e) => {
                            e.preventDefault();
                            window.open(item === null || item === void 0 ? void 0 : item.url, "_blank");
                        } }, item === null || item === void 0 ? void 0 : item.name))))))
            : null));
};
exports["default"] = AckoInfo;
//# sourceMappingURL=acko-info.js.map

/***/ }),

/***/ 23272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(11720));
const footer_styles_1 = __webpack_require__(20223);
const constants_1 = __webpack_require__(28960);
const footerIcons_1 = __webpack_require__(24621);
const useOnScreen_1 = __importDefault(__webpack_require__(71032));
const building_blocks_ui_acko_analytics_1 = __webpack_require__(94262);
const FooterMainContent = ({ isDesktop, segmentProperties, productLinks }) => {
    const [collapsedTitle, setCollapsedTitle] = (0, react_1.useState)('');
    const ref = (0, react_1.useRef)();
    const isFooterVisible = (0, useOnScreen_1.default)(ref);
    const handleAccordian = (subTitle) => {
        setCollapsedTitle(collapsedTitle === subTitle ? '' : subTitle);
        (0, building_blocks_ui_acko_analytics_1.trackEvent)('tap_btn_footer_heading', Object.assign(Object.assign({}, segmentProperties), { header_name: subTitle, vertical_scroll: collapsedTitle === subTitle ? 'collapse' : 'expand' }));
    };
    const handleRedirection = (clickedFooterLink) => {
        (0, building_blocks_ui_acko_analytics_1.trackEvent)('tap_btn_footer_links', Object.assign(Object.assign({}, segmentProperties), { tab_names: [clickedFooterLink === null || clickedFooterLink === void 0 ? void 0 : clickedFooterLink.value], redirection_url: clickedFooterLink === null || clickedFooterLink === void 0 ? void 0 : clickedFooterLink.url }));
        window.open(clickedFooterLink === null || clickedFooterLink === void 0 ? void 0 : clickedFooterLink.url, (clickedFooterLink === null || clickedFooterLink === void 0 ? void 0 : clickedFooterLink.target) || '_self');
    };
    (0, react_1.useEffect)(() => {
        if (isFooterVisible) {
            (0, building_blocks_ui_acko_analytics_1.pageEvent)(constants_1.VIEW_PAGE_FOOTER, Object.assign({}, segmentProperties));
        }
    }, [isFooterVisible]);
    return (react_1.default.createElement(footer_styles_1.FooterMainContentWrapper, { ref: ref, flexDirection: isDesktop ? 'row' : 'column' }, productLinks === null || productLinks === void 0 ? void 0 : productLinks.map((FooterItem, index) => {
        var _a;
        return (react_1.default.createElement(footer_styles_1.FooterItemWrapper, { isDesktop: isDesktop, key: `${FooterItem.title}${index}` },
            react_1.default.createElement(footer_styles_1.FooterItemTitle, { isDesktop: isDesktop, onClick: () => handleAccordian(FooterItem.title) },
                FooterItem.title,
                react_1.default.createElement("span", { className: collapsedTitle !== FooterItem.title
                        ? footer_styles_1.FooterTitleChevronOpen
                        : footer_styles_1.FooterTitleChevronClosed },
                    react_1.default.createElement("img", { src: footerIcons_1.ChevronIcon, alt: "Footer Chevron Icon" }))),
            react_1.default.createElement(footer_styles_1.FooterUlTag, { isVisible: isDesktop ? true : collapsedTitle === FooterItem.title }, (_a = FooterItem.children) === null || _a === void 0 ? void 0 : _a.map((item, index) => (react_1.default.createElement(footer_styles_1.FooterLiTag, { key: `${item === null || item === void 0 ? void 0 : item.url}${index}` },
                react_1.default.createElement(footer_styles_1.FooterAnchorTag, { href: item === null || item === void 0 ? void 0 : item.url, onClick: (e) => {
                        e.preventDefault();
                        handleRedirection(item);
                    }, rel: item === null || item === void 0 ? void 0 : item.rel }, item === null || item === void 0 ? void 0 : item.value)))))));
    })));
};
exports["default"] = FooterMainContent;
//# sourceMappingURL=footer-main-content.js.map

/***/ }),

/***/ 80598:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(11720));
const building_blocks_ui_common_1 = __webpack_require__(79749);
const footer_styles_1 = __webpack_require__(20223);
const footerIcons_1 = __webpack_require__(24621);
const building_blocks_ui_acko_analytics_1 = __webpack_require__(94262);
const FooterSocialLinks = (segmentProperties) => {
    const handleSocialMedia = (url, socialMediaCompany) => {
        (0, building_blocks_ui_acko_analytics_1.trackEvent)('tap_btn_social_media', Object.assign(Object.assign({}, segmentProperties), { redirection_url: url, header_name: socialMediaCompany }));
    };
    return (react_1.default.createElement(building_blocks_ui_common_1.Flex, { mb: '10px', mt: '15px', flexDirection: 'row' },
        react_1.default.createElement(footer_styles_1.FooterSocialA, { target: "_blank", href: "https://www.facebook.com/ackoindia/", rel: "noopener", onClick: () => handleSocialMedia('https://www.facebook.com/ackoindia/', 'Facebook') },
            react_1.default.createElement("img", { src: footerIcons_1.Facebook, alt: 'Facebook Logo' })),
        react_1.default.createElement(footer_styles_1.FooterSocialA, { target: "_blank", href: "https://www.instagram.com/ackoindia/", rel: "noopener", onClick: () => handleSocialMedia("https://www.instagram.com/ackoindia/", 'Instagram') },
            react_1.default.createElement("img", { src: footerIcons_1.Instagram, alt: 'Instagram Logo' })),
        react_1.default.createElement(footer_styles_1.FooterSocialA, { target: "_blank", href: "https://www.linkedin.com/company/acko/", rel: "noopener", onClick: () => handleSocialMedia("https://www.linkedin.com/company/acko/", "LinkedIn") },
            react_1.default.createElement("img", { src: footerIcons_1.Linkedin, alt: 'Linkedin Logo' })),
        react_1.default.createElement(footer_styles_1.FooterSocialA, { target: "_blank", href: "https://twitter.com/AckoIndia", rel: "noopener", onClick: () => handleSocialMedia("https://twitter.com/AckoIndia", "Twitter") },
            react_1.default.createElement("img", { src: footerIcons_1.Twitter, alt: 'Twitter Logo' })),
        react_1.default.createElement(footer_styles_1.FooterSocialA, { target: "_blank", href: "https://www.youtube.com/channel/UCn1gqDU9TqbR8u6_10S0RJA", rel: "noopener", onClick: () => handleSocialMedia("https://twitter.com/AckoIndia", "Youtube") },
            react_1.default.createElement("img", { src: footerIcons_1.Youtube, alt: 'Youtube Logo' }))));
};
exports["default"] = FooterSocialLinks;
//# sourceMappingURL=footer-social-links.js.map

/***/ }),

/***/ 28297:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FooterDataLife = exports.FooterDataGI = exports.FooterData = void 0;
exports.FooterData = {
    productLinks: [
        {
            title: "Products",
            children: [
                {
                    value: "Motor Insurance",
                    url: "/motor-insurance/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance",
                    url: "/car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Bike Insurance",
                    url: "/two-wheeler-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance",
                    url: "/travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "International Travel Insurance",
                    url: "/international-travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "Life Insurance",
                    url: "/life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance",
                    url: "/life-insurance/term-insurance/",
                    target: "_blank",
                },
                {
                    value: "Group Health Insurance",
                    url: "/group-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "ABHA Card",
                    url: "/health-insurance/abha-card-ayushman-bharat-health-account/",
                    target: "_blank",
                },
                {
                    value: "ACKO Drive",
                    url: "https://ackodrive.com/",
                    target: "_blank",
                },
                {
                    value: "Enterprise",
                    url: "/enterprise/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Company",
            children: [
                {
                    value: "About us",
                    url: "/about-us/",
                    target: "_blank",
                },
                {
                    value: "Board of directors",
                    url: "/board-of-directors/",
                    target: "_blank",
                },
                {
                    value: 'Customer stories',
                    url: '/reviews-testimonials/',
                    target: '_blank',
                },
                {
                    value: "Careers",
                    url: "/careers/",
                    target: "_blank",
                },
                {
                    value: "Media kit",
                    url: "/media-kit/",
                    target: "_blank",
                },
                {
                    value: "All resources",
                    url: "/brand-hub/",
                    target: "_blank",
                },
                {
                    value: "Articles",
                    url: "/articles/",
                    target: "_blank",
                },
                {
                    value: "Ackology - The tech blog",
                    url: "/ackology/",
                    target: "_blank",
                },
                {
                    value: "Sitemap",
                    url: "/sitemap/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Legal",
            children: [
                {
                    value: "Financials & disclosures",
                    url: "/financials-disclosures/",
                    target: "_blank",
                },
                {
                    value: "Privacy policy",
                    url: "/privacy-policy/",
                    target: "_blank",
                },
                {
                    value: "Terms & conditions",
                    url: "/terms-and-conditions/",
                    target: "_blank",
                }
            ],
        },
        {
            title: "Support",
            children: [
                {
                    value: "Contact us",
                    url: "/contact-us/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Car Insurance",
            children: [
                {
                    value: "Car Insurance",
                    url: "/car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Comprehensive Car Insurance",
                    url: "/car-insurance/comprehensive-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Third Party Car Insurance",
                    url: "/third-party-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Own Damage Car Insurance",
                    url: "/car-insurance/own-damage-insurance/",
                    target: "_blank",
                },
                {
                    value: "Zero Depreciation Car Insurance",
                    url: "/car-insurance/zero-depreciation/",
                    target: "_blank",
                },
                {
                    value: "Old Car Insurance",
                    url: "/car-insurance/old-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "EV Car Insurance",
                    url: "/car-insurance/electric-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance Calculator",
                    url: "/car-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance Check",
                    url: "/auto/check-vehicle-insurance-status-online/",
                    target: "_blank",
                },
                {
                    value: "Compare Car Insurance",
                    url: "/car-insurance/compare/",
                    target: "_blank",
                },
                {
                    value: "Pay As You Drive Car Insurance",
                    url: "/car-insurance/pay-as-you-drive-insurance/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Bike Insurance",
            children: [
                {
                    value: "Bike Insurance",
                    url: "/two-wheeler-insurance/",
                    target: "_blank",
                },
                {
                    value: "Scooter Insurance",
                    url: "/scooter-insurance/",
                    target: "_blank",
                },
                {
                    value: "Comprehensive Bike Insurance",
                    url: "/two-wheeler-insurance/comprehensive-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Third Party Bike Insurance",
                    url: "/third-party-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Used Bike Insurance",
                    url: "/old-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "EV Bike Insurance",
                    url: "/two-wheeler-insurance/electric-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Own Damage Bike Insurance",
                    url: "/two-wheeler-insurance/standalone-own-damage-insurance/",
                    target: "_blank",
                },
                {
                    value: "Bike Insurance Calculator",
                    url: "/two-wheeler-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Compare Bike Insurance",
                    url: "/two-wheeler-insurance/compare/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Health Insurance",
            children: [
                {
                    value: "Health Insurance",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Plans",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "10 Lakhs Health Insurance",
                    url: "/health-insurance/10-lakhs-sum-insured/",
                    target: "_blank",
                },
                {
                    value: "50 Lakhs Health Insurance",
                    url: "/health-insurance/50-lakhs-sum-insured/",
                    target: "_blank",
                },
                {
                    value: "1 Crore Health Insurance",
                    url: "/health-insurance/1-crore-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Plans For Family",
                    url: "/health-insurance/health-insurance-plans-for-family/",
                    target: "_blank",
                },
                {
                    value: "Individual Health Insurance",
                    url: "/health-insurance/individual-health-insurance-plans/",
                    target: "_blank",
                },
                {
                    value: "Cashless Health Insurance",
                    url: "/health-insurance/cashless/",
                    target: "_blank",
                },
                {
                    value: `Women's Health Insurance`,
                    url: "/health-insurance/for-women/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance For Parents",
                    url: "/health-insurance/for-parents/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance For Senior Citizens",
                    url: "/health-insurance/senior-citizens/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Premium Calculator",
                    url: "/health-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Waiting period in health insurance",
                    url: "/health-insurance/waiting-period/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Portability",
                    url: "/health-insurance/portability/",
                    target: "_blank",
                },
                {
                    value: "Super Top Up Health Insurance",
                    url: "/health-insurance/super-top-up-health-insurance/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Group Health Insurance",
            children: [
                {
                    value: "Group Health Insurance",
                    url: "/group-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Corporate Health Insurance",
                    url: "/corporate-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Group Health Insurance Add-ons",
                    url: "/group-health-insurance/add-ons/",
                    target: "_blank",
                },
                {
                    value: "Maternity Cover In Group Health Insurance",
                    url: "/group-health-insurance/maternity-cover/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Travel Insurance",
            children: [
                {
                    value: "Travel Insurance",
                    url: "/travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "International Travel Insurance",
                    url: "/international-travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "USA Travel Insurance",
                    url: "/international-travel-insurance/usa/",
                    target: "_blank",
                },
                {
                    value: "Schengen Travel Insurance",
                    url: "/international-travel-insurance/schengen/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance for Dubai",
                    url: "/international-travel-insurance/dubai/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance for Thailand",
                    url: "/international-travel-insurance/thailand/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Life Insurance",
            children: [
                {
                    value: "Life Insurance",
                    url: "/life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance",
                    url: "/life-insurance/term-insurance/",
                    target: "_blank",
                },
                {
                    value: "1 Crore Term Insurance",
                    url: "/life-insurance/1-crore-term-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance Calculator",
                    url: "/calculators/term-insurance-calculator/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance for Single Parents",
                    url: "/life-insurance/term-insurance-for-single-parents/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance for Senior Citizens",
                    url: "/life-insurance/term-insurance-for-senior-citizens/",
                    target: "_blank",
                },
                {
                    value: "Affordable Term Insurance",
                    url: "/life-insurance/cheap-term-life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Critical Illness Rider Life Insurance",
                    url: "/life-insurance/critical-illness-insurance/",
                    target: "_blank",
                },
                {
                    value: "Accidental Death Benefit Rider In Life Insurance",
                    url: "/life-insurance/accidental-death-benefit-rider/",
                    target: "_blank",
                },
                {
                    value: "Disability Income Rider",
                    url: "/life-insurance/disability-income-rider/",
                    target: "_blank",
                },
            ],
        },
    ],
    policyWording: [
        {
            label: "CIN: U74110KA2016PLC120161",
        },
    ],
    policyWordingText: [
        {
            text: `The use of images and brands are only for the purpose of indication and illustration.`,
            disclaimer: true,
            isLpv2: {
                status: false,
            },
        },
        {
            text: `The use of images and brands are only for the purpose of
      indication and illustration. ACKO claims no rights on the IP
      rights of any third parties.`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `Trade logo displayed above belongs to Acko Technology and Services Limited
      (formerly known as Acko Technology and Services Private Limited) and used by ACKO General insurance Limited under License.
      For more details on risk factors, terms, conditions and
      exclusions, please read the policy wordings carefully before
      concluding a sale.`,
            isLpv2: {
                status: true,
            },
            isLineBreak: true,
        },
        {
            text: `The ratings are derived from reviews and feedback received from
      Twitter and Google users on their respective platforms. The use of
      testimonials are purely on an as is basis and as expressed by the
      Customers, independently. ACKO claims no rights on the IP, if any,
      of third parties and ACKO disclaims all claims, liabilities
      arising in relation there to.`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `The claims numbers are as of 31st Jan 2021 and not an indication
      of company's future performance.`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `Same day claim settlement* for eligible car & bike claims only.`,
            isLpv2: {
                status: true,
                value: "ipl",
            },
        },
        {
            text: `* Claim amount shall be paid upfront for all the small claims
      and minor damages on the same day.`,
            isLpv2: {
                status: true,
                value: "ipl",
            },
        },
        {
            text: `*ACKO General Insurance has been recognised as one of the 'Most
      Trusted Brands of India 2021' by Team Marksmen and their Media
      Partner- CNBCTV18`,
            isLpv2: {
                status: true,
                value: "ipl",
            },
        },
        {
            text: `**ACKO General Insurance Ltd. has been recognised as one of the
      'Most Trusted Brands of India – Best Digital Insurance Brand' by
      Team Marksmen and their Media Partner- CNBCTV18`,
            isLpv2: {
                status: true,
                value: "default",
            },
        },
        {
            text: `*Applicable only in select cities`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `*T&C Apply`,
            isLpv2: {
                status: true,
            },
        },
    ],
    infoWording: {
        heading: "Acko Technology and Services Limited (formerly known as Acko Technology and Services Private Limited)",
        headingItem: `#36/5, Hustlehub One East,
      Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout,
      Bengaluru, Karnataka 560102`,
        groupCompanies: {
            title: "Acko Group Companies:",
            lists: [
                {
                    name: "Acko General Insurance Limited",
                    url: "/gi",
                },
                {
                    name: "Acko Life Insurance Limited",
                    url: "/life",
                },
            ],
        },
        showSocialLinks: true,
    },
    isLifeFooter: false,
};
exports.FooterDataGI = {
    productLinks: [
        {
            title: "Products",
            children: [
                {
                    value: "Motor Insurance",
                    url: "/motor-insurance/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance",
                    url: "/car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Bike Insurance",
                    url: "/two-wheeler-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance",
                    url: "/travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "International Travel Insurance",
                    url: "/international-travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "Life Insurance",
                    url: "/life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance",
                    url: "/life-insurance/term-insurance/",
                    target: "_blank",
                },
                {
                    value: "Group Health Insurance",
                    url: "/group-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "ABHA Card",
                    url: "/health-insurance/abha-card-ayushman-bharat-health-account/",
                    target: "_blank",
                },
                {
                    value: "Enterprise",
                    url: "/enterprise/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Company",
            children: [
                {
                    value: "About us",
                    url: "/gi/about-us/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Board of directors",
                    url: "/gi/board-of-directors/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: 'Customer stories',
                    url: '/reviews-testimonials/',
                    target: '_blank',
                },
                {
                    value: "Media kit",
                    url: "/gi/media-kit/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Partnerships",
                    url: "/gi/partnerships/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Sitemap",
                    url: "/gi/sitemap/",
                    target: "_blank",
                },
                {
                    value: "CSR Policy",
                    url: "https://acko-cms.ackoassets.com/CSR_policy_1b37e6961c.pdf",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Legal",
            children: [
                {
                    value: 'Products offered/withdrawn',
                    url: '/gi/products-offered-withdrawn/',
                    target: '_blank',
                },
                {
                    value: "Public disclosure",
                    url: "/gi/public-disclosure/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Financials & disclosures",
                    url: "/gi/financials-disclosures/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Privacy policy",
                    url: "/gi/privacy-policy/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Terms & conditions",
                    url: "/gi/terms-and-conditions/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Stewardship code",
                    url: "/wp-content/uploads/2018/07/policy-on-stewardship-code.pdf",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Disclaimer",
                    url: "/gi/disclaimer/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Anti fraud policy",
                    url: "/wp-content/uploads/2020/06/anti-fraud-policy.pdf",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Health underwriting philosophy",
                    url: "/wp-content/uploads/2020/10/acko-health-underwriting-philosophy.pdf",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "IDV Criteria (Motor)",
                    url: "https://acko-cms.ackoassets.com/Criteria_for_arriving_at_IDV_17baebfa67.pdf",
                    target: "_blank"
                },
                {
                    value: "Total Loss/CTL criteria (Motor)",
                    url: "https://acko-cms.ackoassets.com/Criteria_for_considering_as_Total_Loss_Constructive_Total_Loss_2_e12c5a2bd6.pdf",
                    target: "_blank"
                },
                {
                    value: "Policy on Protection of Policyholders’ Interest",
                    url: "https://acko-cms.ackoassets.com/Oct_PPPHI_f9f3a0d4ea.pdf",
                    target: "_blank",
                },
                {
                    value: "List of Brokers & CA",
                    url: "https://acko-cms.ackoassets.com/List_of_Broker_and_CA_b2698a6742.xlsx",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Support",
            children: [
                {
                    value: "Contact us",
                    url: "/gi/contact-us/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Customer service",
                    url: "/gi/customer-service/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Cancellations & refunds",
                    url: "/gi/cancellation-and-refund-policy/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Downloads",
                    url: "/gi/download/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Unclaimed amount",
                    url: "/gi/unclaimed-amount/",
                    target: "_blank",
                },
                {
                    value: "IRDAI website",
                    url: "https://www.irdai.gov.in/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "IRDAI's Call Centre Feedback Survey",
                    url: "https://www.mygov.in/mygov-survey/irdais-call-centre-feedback-survey/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Bima Bharosa",
                    url: "https://bimabharosa.irdai.gov.in/Home/Home",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Ayushman Bharat Health Account Creation",
                    url: "https://healthid.ndhm.gov.in/",
                    target: "_blank",
                    rel: "nofollow,noindex",
                },
                {
                    value: "Service Turnaround Times",
                    url: "/gi/customer-service/turn-around-time/",
                    target: "_blank",
                    rel: "",
                },
            ],
        },
        {
            title: "Car Insurance",
            children: [
                {
                    value: "Car Insurance",
                    url: "/car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Comprehensive Car Insurance",
                    url: "/car-insurance/comprehensive-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Third Party Car Insurance",
                    url: "/third-party-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Own Damage Car Insurance",
                    url: "/car-insurance/own-damage-insurance/",
                    target: "_blank",
                },
                {
                    value: "Zero Depreciation Car Insurance",
                    url: "/car-insurance/zero-depreciation/",
                    target: "_blank",
                },
                {
                    value: "Old Car Insurance",
                    url: "/car-insurance/old-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "EV Car Insurance",
                    url: "/car-insurance/electric-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance Calculator",
                    url: "/car-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance Check",
                    url: "/auto/check-vehicle-insurance-status-online/",
                    target: "_blank",
                },
                {
                    value: "Compare Car Insurance",
                    url: "/car-insurance/compare/",
                    target: "_blank",
                },
                {
                    value: "Pay As You Drive Car Insurance",
                    url: "/car-insurance/pay-as-you-drive-insurance/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Bike Insurance",
            children: [
                {
                    value: "Bike Insurance",
                    url: "/two-wheeler-insurance/",
                    target: "_blank",
                },
                {
                    value: "Scooter Insurance",
                    url: "/scooter-insurance/",
                    target: "_blank",
                },
                {
                    value: "Comprehensive Bike Insurance",
                    url: "/two-wheeler-insurance/comprehensive-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Third Party Bike Insurance",
                    url: "/third-party-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Used Bike Insurance",
                    url: "/old-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "EV Bike Insurance",
                    url: "/two-wheeler-insurance/electric-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Own Damage Bike Insurance",
                    url: "/two-wheeler-insurance/standalone-own-damage-insurance/",
                    target: "_blank",
                },
                {
                    value: "Bike Insurance Calculator",
                    url: "/two-wheeler-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Compare Bike Insurance",
                    url: "/two-wheeler-insurance/compare/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Health Insurance",
            children: [
                {
                    value: "Health Insurance",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Plans",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "10 Lakhs Health Insurance",
                    url: "/health-insurance/10-lakhs-sum-insured/",
                    target: "_blank",
                },
                {
                    value: "50 Lakhs Health Insurance",
                    url: "/health-insurance/50-lakhs-sum-insured/",
                    target: "_blank",
                },
                {
                    value: "1 Crore Health Insurance",
                    url: "/health-insurance/1-crore-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Plans For Family",
                    url: "/health-insurance/health-insurance-plans-for-family/",
                    target: "_blank",
                },
                {
                    value: "Individual Health Insurance",
                    url: "/health-insurance/individual-health-insurance-plans/",
                    target: "_blank",
                },
                {
                    value: "Cashless Health Insurance",
                    url: "/health-insurance/cashless/",
                    target: "_blank",
                },
                {
                    value: `Women's Health Insurance`,
                    url: "/health-insurance/for-women/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance For Parents",
                    url: "/health-insurance/for-parents/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance For Senior Citizens",
                    url: "/health-insurance/senior-citizens/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Premium Calculator",
                    url: "/health-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Waiting period in health insurance",
                    url: "/health-insurance/waiting-period/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Portability",
                    url: "/health-insurance/portability/",
                    target: "_blank",
                },
                {
                    value: "Super Top Up Health Insurance",
                    url: "/health-insurance/super-top-up-health-insurance/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Group Health Insurance",
            children: [
                {
                    value: "Group Health Insurance",
                    url: "/group-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Corporate Health Insurance",
                    url: "/corporate-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Group Health Insurance Add-ons",
                    url: "/group-health-insurance/add-ons/",
                    target: "_blank",
                },
                {
                    value: "Maternity Cover In Group Health Insurance",
                    url: "/group-health-insurance/maternity-cover/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Travel Insurance",
            children: [
                {
                    value: "Travel Insurance",
                    url: "/travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "International Travel Insurance",
                    url: "/international-travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "USA Travel Insurance",
                    url: "/international-travel-insurance/usa/",
                    target: "_blank",
                },
                {
                    value: "Schengen Travel Insurance",
                    url: "/international-travel-insurance/schengen/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance for Dubai",
                    url: "/international-travel-insurance/dubai/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance for Thailand",
                    url: "/international-travel-insurance/thailand/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance Calculator",
                    url: "/gi/p/travel/international-insurance",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Life Insurance",
            children: [
                {
                    value: "Life Insurance",
                    url: "/life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance",
                    url: "/life-insurance/term-insurance/",
                    target: "_blank",
                },
                {
                    value: "1 Crore Term Insurance",
                    url: "/life-insurance/1-crore-term-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance Calculator",
                    url: "/calculators/term-insurance-calculator/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance for Single Parents",
                    url: "/life-insurance/term-insurance-for-single-parents/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance for Senior Citizens",
                    url: "/life-insurance/term-insurance-for-senior-citizens/",
                    target: "_blank",
                },
                {
                    value: "Affordable Term Insurance",
                    url: "/life-insurance/cheap-term-life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Critical Illness Rider Life Insurance",
                    url: "/life-insurance/critical-illness-insurance/",
                    target: "_blank",
                },
                {
                    value: "Accidental Death Benefit Rider In Life Insurance",
                    url: "/life-insurance/accidental-death-benefit-rider/",
                    target: "_blank",
                },
                {
                    value: "Disability Income Rider",
                    url: "/life-insurance/disability-income-rider/",
                    target: "_blank",
                },
            ],
        },
    ],
    policyWording: [
        {
            label: "CIN: U66000KA2016PLC138288",
        },
        {
            label: "IRDAI Registration No: 157",
        },
        {
            label: "Category: Non-Life Insurance",
        },
    ],
    policyWordingText: [
        {
            text: `The use of images and brands are only for the purpose of
      indication and illustration. ACKO claims no rights on the IP
      rights of any third parties. The ratings are derived from reviews
      and feedback received from Google and Facebook users on their
      respective platforms. | *Discount is calculated basis F&U filling rates.`,
            disclaimer: true,
            isLpv2: {
                status: false,
            },
        },
        {
            text: `Trade logo displayed above belongs to Acko Technology and Services Limited (formerly known as Acko Technology and Services Private Limited) and used by ACKO General insurance Limited under License.
      For more details on risk factors, terms, conditions and
      exclusions, please read the policy wordings carefully before
      concluding a sale. | 98% claim settlement ratio is based on cumulative claims data across all LOBs for FY 2024–25. `,
            isLpv2: {
                status: false,
            },
        },
        {
            text: `The use of images and brands are only for the purpose of
      indication and illustration. ACKO claims no rights on the IP
      rights of any third parties.`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `Trade logo displayed above belongs to Acko Technology and Services Limited (formerly known as Acko Technology and Services Private Limited) and used by ACKO General insurance Limited under License.
      For more details on risk factors, terms, conditions and
      exclusions, please read the policy wordings carefully before
      concluding a sale.`,
            isLpv2: {
                status: true,
            },
            isLineBreak: true,
        },
        {
            text: `The ratings are derived from reviews and feedback received from
      Twitter and Google users on their respective platforms. The use of
      testimonials are purely on an as is basis and as expressed by the
      Customers, independently. ACKO claims no rights on the IP, if any,
      of third parties and ACKO disclaims all claims, liabilities
      arising in relation there to.`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `The claims numbers are as of 31st Jan 2021 and not an indication
      of company's future performance.`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `Same day claim settlement* for eligible car & bike claims only.`,
            isLpv2: {
                status: true,
                value: "ipl",
            },
        },
        {
            text: `* Claim amount shall be paid upfront for all the small claims
      and minor damages on the same day.`,
            isLpv2: {
                status: true,
                value: "ipl",
            },
        },
        {
            text: `*ACKO General Insurance has been recognised as one of the 'Most
      Trusted Brands of India 2021' by Team Marksmen and their Media
      Partner- CNBCTV18`,
            isLpv2: {
                status: true,
                value: "ipl",
            },
        },
        {
            text: `**ACKO General Insurance Ltd. has been recognised as one of the
      'Most Trusted Brands of India – Best Digital Insurance Brand' by
      Team Marksmen and their Media Partner- CNBCTV18`,
            isLpv2: {
                status: true,
                value: "default",
            },
        },
        {
            text: `*Applicable only in select cities`,
            isLpv2: {
                status: true,
            },
        },
        {
            text: `*T&C Apply`,
            isLpv2: {
                status: true,
            },
        },
    ],
    infoWording: {
        heading: "ACKO General Insurance Limited",
        headingItem: `2nd Floor, #36/5, Hustlehub One East,
      Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout,
      Bengaluru, Karnataka 560102`,
        showSocialLinks: true,
    },
    isLifeFooter: false,
};
exports.FooterDataLife = {
    productLinks: [
        {
            title: "Products",
            children: [
                {
                    value: "Motor Insurance",
                    url: "/motor-insurance/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance",
                    url: "/car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Bike Insurance",
                    url: "/two-wheeler-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance",
                    url: "/travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "International Travel Insurance",
                    url: "/international-travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "Life Insurance",
                    url: "/life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance",
                    url: "/life-insurance/term-insurance/",
                    target: "_blank",
                },
                {
                    value: "Group Health Insurance",
                    url: "/group-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "ABHA Card",
                    url: "/health-insurance/abha-card-ayushman-bharat-health-account/",
                    target: "_blank",
                },
                {
                    value: "Enterprise",
                    url: "/enterprise/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Company",
            children: [
                {
                    value: "About us",
                    url: "/life/about-us/",
                    target: "_blank",
                },
                {
                    value: "Board of directors",
                    url: "/life/board-of-directors/",
                    target: "_blank",
                },
                {
                    value: 'Customer stories',
                    url: '/reviews-testimonials/',
                    target: '_blank',
                },
                {
                    value: "Careers",
                    url: "/careers/",
                    target: "_blank",
                },
                {
                    value: "All resources",
                    url: "/brand-hub/",
                    target: "_blank",
                },
                {
                    value: "Articles",
                    url: "/articles/",
                    target: "_blank",
                },
                {
                    value: "Ackology - The tech blog",
                    url: "/ackology/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Legal",
            children: [
                {
                    value: "Public disclosure",
                    url: "/life/public-disclosure/",
                    target: "_blank",
                },
                {
                    value: "Financials & disclosures",
                    url: "/life/financials-disclosures/",
                    target: "_blank",
                },
                {
                    value: "Privacy policy",
                    url: "/life/privacy-policy/",
                    target: "_blank",
                },
                {
                    value: "Terms & conditions",
                    url: "/life/terms-and-conditions/",
                    target: "_blank",
                },
                {
                    value: "Stewardship code",
                    url: "https://acko-cms.ackoassets.com/ALIL_Stewardship_Policy_64f0bc7056.pdf",
                    target: "_blank",
                },
                {
                    value: "Disclaimer",
                    url: "/life/disclaimer/",
                    target: "_blank",
                },
                {
                    value: "Anti fraud policy",
                    url: "https://assets.ctfassets.net/uwf0n1j71a7j/3yYpbCoFHzDIDAAAWyzxM9/d88a2b9942ecf32ada3ceadd5aabf890/Acko_Life_Anti-Fraud_Policy__1_.pdf",
                    target: "_blank",
                },
                {
                    value: "Life underwriting philosophy",
                    url: "https://assets.ctfassets.net/uwf0n1j71a7j/4uZqE2io3qvsu6oeW4Q8nn/45b0243640f4232172813cee326539ae/Acko_Life_UW_Philosophy_for_PWD_and_HIV.pdf",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Support",
            children: [
                {
                    value: "Contact us",
                    url: "/life/contact-us/",
                    target: "_blank",
                },
                {
                    value: "Customer service",
                    url: "/life/customer-service/",
                    target: "_blank",
                },
                {
                    value: "Cancellations & refunds",
                    url: "/life/cancellation-and-refund-policy/",
                    target: "_blank",
                },
                {
                    value: "Downloads",
                    url: "/life/download/",
                    target: "_blank",
                },
                {
                    value: "IRDAI website",
                    url: "https://www.irdai.gov.in/",
                    target: "_blank",
                    rel: "nofollow",
                },
                {
                    value: "IRDAI's Call Centre Feedback Survey",
                    url: "https://www.mygov.in/mygov-survey/irdais-call-centre-feedback-survey/",
                    target: "_blank",
                    rel: "nofollow",
                },
                {
                    value: "Bima Bharosa",
                    url: "https://bimabharosa.irdai.gov.in/Home/Home",
                    target: "_blank",
                    rel: "nofollow",
                },
                {
                    value: "Ayushman Bharat Health Account Creation",
                    url: "https://healthid.ndhm.gov.in/",
                    target: "_blank",
                    rel: "nofollow",
                },
                {
                    value: 'List of Insurance Ombudsman',
                    url: 'https://www.cioins.co.in/Ombudsman',
                    target: '_blank',
                },
                {
                    value: 'Grievance Redressal Procedure',
                    url: '/life/customer-service/grievance-redressal/',
                    target: '_blank',
                },
                {
                    value: 'Service Turnaround times',
                    url: '/life/customer-service-tats/',
                    target: '_blank',
                },
                {
                    value: 'Unclaimed amount',
                    url: '/life/unclaimed-amount/',
                    target: '_blank',
                },
                {
                    value: 'List of Active/Withdrawn Products',
                    url: '/life/product-disclosures/',
                    target: '_blank',
                },
                {
                    value: 'Distribution Channel',
                    url: '/life/distribution-channel/',
                    target: '_blank',
                },
                {
                    value: 'Claims',
                    url: '/life/claims/',
                    target: '_blank',
                },
            ],
        },
        {
            title: "Car Insurance",
            children: [
                {
                    value: "Car Insurance",
                    url: "/car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Comprehensive Car Insurance",
                    url: "/car-insurance/comprehensive-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Third Party Car Insurance",
                    url: "/third-party-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Own Damage Car Insurance",
                    url: "/car-insurance/own-damage-insurance/",
                    target: "_blank",
                },
                {
                    value: "Zero Depreciation Car Insurance",
                    url: "/car-insurance/zero-depreciation/",
                    target: "_blank",
                },
                {
                    value: "Old Car Insurance",
                    url: "/car-insurance/old-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "EV Car Insurance",
                    url: "/car-insurance/electric-car-insurance/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance Calculator",
                    url: "/car-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Car Insurance Check",
                    url: "/auto/check-vehicle-insurance-status-online/",
                    target: "_blank",
                },
                {
                    value: "Compare Car Insurance",
                    url: "/car-insurance/compare/",
                    target: "_blank",
                },
                {
                    value: "Pay As You Drive Car Insurance",
                    url: "/car-insurance/pay-as-you-drive-insurance/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Bike Insurance",
            children: [
                {
                    value: "Bike Insurance",
                    url: "/two-wheeler-insurance/",
                    target: "_blank",
                },
                {
                    value: "Scooter Insurance",
                    url: "/scooter-insurance/",
                    target: "_blank",
                },
                {
                    value: "Comprehensive Bike Insurance",
                    url: "/two-wheeler-insurance/comprehensive-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Third Party Bike Insurance",
                    url: "/third-party-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Used Bike Insurance",
                    url: "/old-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "EV Bike Insurance",
                    url: "/two-wheeler-insurance/electric-bike-insurance/",
                    target: "_blank",
                },
                {
                    value: "Own Damage Bike Insurance",
                    url: "/two-wheeler-insurance/standalone-own-damage-insurance/",
                    target: "_blank",
                },
                {
                    value: "Bike Insurance Calculator",
                    url: "/two-wheeler-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Compare Bike Insurance",
                    url: "two-wheeler-insurance/compare",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Health Insurance",
            children: [
                {
                    value: "Health Insurance",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Plans",
                    url: "/health-insurance/",
                    target: "_blank",
                },
                {
                    value: "10 Lakhs Health Insurance",
                    url: "/health-insurance/10-lakhs-sum-insured/",
                    target: "_blank",
                },
                {
                    value: "50 Lakhs Health Insurance",
                    url: "health-insurance/corona-kavach-policy/",
                    target: "_blank",
                },
                {
                    value: "1 Crore Health Insurance",
                    url: "/health-insurance/1-crore-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Plans For Family",
                    url: "/health-insurance/health-insurance-plans-for-family/",
                    target: "_blank",
                },
                {
                    value: "Individual Health Insurance",
                    url: "/health-insurance/individual-health-insurance-plans/",
                    target: "_blank",
                },
                {
                    value: "Cashless Health Insurance",
                    url: "health-insurance/cashless/",
                    target: "_blank",
                },
                {
                    value: `Women's Health Insurance`,
                    url: "/health-insurance/for-women/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance For Parents",
                    url: "/health-insurance/for-parents/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance For Senior Citizens",
                    url: "/health-insurance/senior-citizens/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Premium Calculator",
                    url: "/health-insurance/premium-calculator/",
                    target: "_blank",
                },
                {
                    value: "Waiting period in health insurance",
                    url: "/health-insurance/waiting-period/",
                    target: "_blank",
                },
                {
                    value: "Health Insurance Portability",
                    url: "/health-insurance/portability/",
                    target: "_blank",
                },
                {
                    value: "Super Top Up Health Insurance",
                    url: "/health-insurance/super-top-up-health-insurance/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Group Health Insurance",
            children: [
                {
                    value: "Group Health Insurance",
                    url: "/group-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Corporate Health Insurance",
                    url: "/corporate-health-insurance/",
                    target: "_blank",
                },
                {
                    value: "Group Health Insurance Add-ons",
                    url: "/group-health-insurance/add-ons/",
                    target: "_blank",
                },
                {
                    value: "Maternity Cover In Group Health Insurance",
                    url: "/group-health-insurance/maternity-cover/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Travel Insurance",
            children: [
                {
                    value: "Travel Insurance",
                    url: "/travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "International Travel Insurance",
                    url: "/international-travel-insurance/",
                    target: "_blank",
                },
                {
                    value: "USA Travel Insurance",
                    url: "/international-travel-insurance/usa/",
                    target: "_blank",
                },
                {
                    value: "Schengen Travel Insurance",
                    url: "/international-travel-insurance/schengen/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance for Dubai",
                    url: "/international-travel-insurance/dubai/",
                    target: "_blank",
                },
                {
                    value: "Travel Insurance for Thailand",
                    url: "/international-travel-insurance/thailand/",
                    target: "_blank",
                },
            ],
        },
        {
            title: "Life Insurance",
            children: [
                {
                    value: "Life Insurance",
                    url: "/life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance",
                    url: "/life-insurance/term-insurance/",
                    target: "_blank",
                },
                {
                    value: "1 Crore Term Insurance",
                    url: "/life-insurance/1-crore-term-insurance/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance Calculator",
                    url: "/calculators/term-insurance-calculator/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance for Single Parents",
                    url: "/life-insurance/term-insurance-for-single-parents/",
                    target: "_blank",
                },
                {
                    value: "Term Insurance for Senior Citizens",
                    url: "/life-insurance/term-insurance-for-senior-citizens/",
                    target: "_blank",
                },
                {
                    value: "Affordable Term Insurance",
                    url: "/life-insurance/cheap-term-life-insurance/",
                    target: "_blank",
                },
                {
                    value: "Critical Illness Rider Life Insurance",
                    url: "/life-insurance/critical-illness-insurance/",
                    target: "_blank",
                },
                {
                    value: "Accidental Death Benefit Rider In Life Insurance",
                    url: "/life-insurance/accidental-death-benefit-rider/",
                    target: "_blank",
                },
                {
                    value: "Disability Income Rider",
                    url: "/life-insurance/disability-income-rider/",
                    target: "_blank",
                },
            ],
        },
    ],
    policyWording: [
        {
            label: "CIN: U66010KA2022PLC163629",
        },
        {
            label: "IRDAI Registration No: 164",
        },
        {
            label: "Category: Life Insurance",
        },
    ],
    policyWordingText: [
        {
            text: `The use of third-party images and brands are for
      indicative and illustrative purposes only, ACKO Life
      Insurance Limited claims no rights on the intellectual
      property of any third party/ies.  The user rating and
      feedback are derived from third-party platform/s like
      Facebook and Google.`,
        },
        {
            text: `The trade logo and URL belongs to Acko Technology and Services Limited (formerly known as Acko Technology and Services Private Limited) and is being used by ACKO
      Life Insurance Limited under a license. For more details
      on risk factors, terms, conditions and exclusions, please
      read the policy wordings carefully before concluding a sale.`,
        },
        {
            text: `IRDAI or its officials do not involve in activities like selling insurance policies, announcing bonus or investment of premiums. Public receiving such phone calls are requested to lodge a police complaint.`,
        },
    ],
    infoWording: {
        heading: "ACKO Life Insurance Limited",
        headingItem: `#36/5, Hustlehub One East,
    Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout,
    Bengaluru, Karnataka 560102`,
        showSocialLinks: false,
    },
    isLifeFooter: true,
};
//# sourceMappingURL=list-Footer-links.js.map

/***/ }),

/***/ 96117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(11720));
const footer_styles_1 = __webpack_require__(20223);
const PolicyWordingsFooter = ({ isLpv2 = false, isDesktop, disclaimer, policyWording, policyWordingText, isLifeFooter = false, BeemaLokpal, complianceLinks, }) => {
    const isTextRowAvailable = (isLpv2, schemaIsLpv2) => {
        if (!isLpv2 && !(schemaIsLpv2 === null || schemaIsLpv2 === void 0 ? void 0 : schemaIsLpv2.status)) {
            return true;
        }
        else if (isLpv2 && (schemaIsLpv2 === null || schemaIsLpv2 === void 0 ? void 0 : schemaIsLpv2.status)) {
            if (!(schemaIsLpv2 === null || schemaIsLpv2 === void 0 ? void 0 : schemaIsLpv2.value))
                return true;
            else if ((schemaIsLpv2 === null || schemaIsLpv2 === void 0 ? void 0 : schemaIsLpv2.value) === "ipl" && isLpv2.toString() === "ipl")
                return true;
            else if ((schemaIsLpv2 === null || schemaIsLpv2 === void 0 ? void 0 : schemaIsLpv2.value) !== "ipl" && isLpv2.toString() !== "ipl")
                return true;
        }
        return false;
    };
    return (react_1.default.createElement(footer_styles_1.BottomWrapper, null,
        react_1.default.createElement(footer_styles_1.BottomContainer, { gap: "32", isDesktop: isDesktop },
            react_1.default.createElement(footer_styles_1.FooterColumn, null,
                react_1.default.createElement(footer_styles_1.FooterRow, null, Array.isArray(complianceLinks) &&
                    complianceLinks.map((link, index) => {
                        var _a;
                        return (link === null || link === void 0 ? void 0 : link.value) &&
                            (link === null || link === void 0 ? void 0 : link.url) && (react_1.default.createElement(footer_styles_1.BottomLink, { key: link.url || index, href: link.url, target: (_a = link === null || link === void 0 ? void 0 : link.target) !== null && _a !== void 0 ? _a : "_self" }, link.value));
                    })),
                react_1.default.createElement(footer_styles_1.FooterRow, null, policyWording.map((PolicyWordingItem) => {
                    return react_1.default.createElement(footer_styles_1.BottomLabel, null, PolicyWordingItem.label);
                })),
                react_1.default.createElement(footer_styles_1.FooterRow, null, policyWordingText.map((WordingTextItem) => {
                    var _a;
                    if (isTextRowAvailable(isLpv2, WordingTextItem === null || WordingTextItem === void 0 ? void 0 : WordingTextItem.isLpv2)) {
                        return (react_1.default.createElement(footer_styles_1.BottomLabelSecondary, { isLpv2: (_a = WordingTextItem === null || WordingTextItem === void 0 ? void 0 : WordingTextItem.isLpv2) === null || _a === void 0 ? void 0 : _a.status, isLineBreak: WordingTextItem === null || WordingTextItem === void 0 ? void 0 : WordingTextItem.isLineBreak },
                            WordingTextItem.text,
                            !!disclaimer && (WordingTextItem === null || WordingTextItem === void 0 ? void 0 : WordingTextItem.disclaimer) && (react_1.default.createElement("span", null, disclaimer))));
                    }
                }))),
            BeemaLokpal && react_1.default.createElement("div", null, BeemaLokpal))));
};
exports["default"] = PolicyWordingsFooter;
//# sourceMappingURL=policy-wordings.js.map

/***/ }),

/***/ 2758:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.r2d2 = r2d2;
exports.cookie = cookie;
exports.cookieWithVal = cookieWithVal;
const axios_1 = __importDefault(__webpack_require__(5165));
function r2d2(in_, requestUrl) {
    return axios_1.default.post(requestUrl, Object.assign(Object.assign({ app: "NS_Container", ua: window === null || window === void 0 ? void 0 : window.navigator.userAgent, user: in_.user || cookie("user_id"), tracker: in_.tracker || cookie("trackerid") }, in_), { edata: Object.assign(Object.assign({}, (in_.edata || {})), { anonymousID: webengageAnonymousID(), ga_client_id: getGAClientID(), is_js: true, platform: window.innerWidth < 480 ? "mweb" : "web", web_engage: true }), odata: Object.assign(Object.assign({}, (in_.odata || {})), { url: window === null || window === void 0 ? void 0 : window.location.href }) }), {
        withCredentials: true,
        timeout: 4000,
    });
}
function getGAClientID() {
    try {
        return window["ga"].getAll()[0].get("clientId");
    }
    catch (_a) {
        return "";
    }
}
function webengageAnonymousID() {
    let aid = cookie("we_aid");
    if (aid !== undefined)
        return aid;
    try {
        // @ts-ignore
        aid = window.webengage.user.getAnonymousId();
    }
    catch (_a) {
        aid = "";
    }
    return aid;
}
function cookie(key) {
    if (typeof document === "undefined")
        return;
    if (document.cookie.indexOf(`${key}=`) === -1)
        return;
    return document.cookie.split(`${key}=`)[1].split(";")[0];
}
function cookieWithVal(key, value) {
    if (typeof document === "undefined")
        return;
    if (typeof key === "string" && typeof value === "string") {
        document.cookie = `${key}=${value};path=/`;
        return value;
    }
    if (document.cookie.indexOf(`${key}=`) === -1)
        return;
    return document.cookie.split(`${key}=`)[1].split(";")[0];
}
//# sourceMappingURL=r2d2.js.map

/***/ }),

/***/ 28960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VIEW_PAGE_FOOTER = void 0;
exports.VIEW_PAGE_FOOTER = 'view_page_footer';
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 55831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Footer = Footer;
const react_1 = __importDefault(__webpack_require__(11720));
const footer_styles_1 = __webpack_require__(20223);
const acko_info_1 = __importDefault(__webpack_require__(17447));
const acko_download_app_1 = __importDefault(__webpack_require__(96276));
const policy_wordings_1 = __importDefault(__webpack_require__(96117));
const footer_main_content_1 = __importDefault(__webpack_require__(23272));
const list_Footer_links_1 = __webpack_require__(28297);
const footerIcons_1 = __webpack_require__(24621);
// version bump
function Footer({ requestUrl, isDesktop, isLpv2, segmentProperties, disclaimer, schema = list_Footer_links_1.FooterData, BeemaLokpal, complianceLinks = [] }) {
    return (react_1.default.createElement(footer_styles_1.FooterWrapper, { flexDirection: "column" },
        react_1.default.createElement(footer_styles_1.MainContainer, { isDesktop: isDesktop },
            react_1.default.createElement(footer_styles_1.FooterRow, null,
                react_1.default.createElement("img", { style: { width: 100, height: 32 }, src: footerIcons_1.AckoCompanyLogo })),
            react_1.default.createElement(footer_styles_1.FooterRow, { justifyContent: "center", needSeparator: true, noWrap: true },
                react_1.default.createElement(footer_styles_1.FooterItem, { flexBasis: isDesktop ? "55%" : "100%" },
                    react_1.default.createElement(acko_info_1.default, { infoWording: schema === null || schema === void 0 ? void 0 : schema.infoWording })),
                isDesktop ? (react_1.default.createElement(footer_styles_1.FooterItem, { flexBasis: "45%" },
                    react_1.default.createElement(acko_download_app_1.default, { requestUrl: requestUrl, isMobile: false }))) : null),
            react_1.default.createElement(footer_styles_1.FooterRow, null,
                react_1.default.createElement(footer_styles_1.FooterItem, null,
                    react_1.default.createElement(footer_main_content_1.default, { segmentProperties: segmentProperties, isDesktop: isDesktop, productLinks: schema === null || schema === void 0 ? void 0 : schema.productLinks }))),
            !isDesktop ? (react_1.default.createElement(footer_styles_1.FooterRow, null,
                react_1.default.createElement(footer_styles_1.FooterItem, { needBorderSpacing: true },
                    react_1.default.createElement(acko_download_app_1.default, { requestUrl: requestUrl, isMobile: true })))) : null),
        react_1.default.createElement(policy_wordings_1.default, { isLpv2: isLpv2, isDesktop: isDesktop, disclaimer: disclaimer, policyWording: schema === null || schema === void 0 ? void 0 : schema.policyWording, policyWordingText: schema === null || schema === void 0 ? void 0 : schema.policyWordingText, isLifeFooter: schema === null || schema === void 0 ? void 0 : schema.isLifeFooter, complianceLinks: complianceLinks, BeemaLokpal: BeemaLokpal })));
}
//# sourceMappingURL=footer.js.map

/***/ }),

/***/ 20223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GroupCompanyAnchorTag = exports.GroupCompanyLiTag = exports.GroupCompanyUlTag = exports.GroupCompanyHeading = exports.GroupCompanies = exports.Image = exports.BottomLabelSecondary = exports.BottomLabel = exports.BottomLink = exports.BottomContainer = exports.BottomWrapper = exports.DownloadContainer = exports.DownloadHeading = exports.AppleStoreLink = exports.GooglePlayLink = exports.AppStoreContainer = exports.StoreImageLink = exports.FooterSocialA = exports.HeadingItem = exports.Heading = exports.AckoInfoWrapper = exports.FooterItem = exports.FooterColumn = exports.FooterRow = exports.FooterTitleChevronClosed = exports.FooterTitleChevronOpen = exports.FooterItemTitle = exports.FooterItemWrapper = exports.FooterAnchorTag = exports.FooterLiTag = exports.FooterUlTag = exports.FooterMainContentWrapper = exports.MainContainer = exports.FooterWrapper = void 0;
const building_blocks_ui_common_1 = __webpack_require__(79749);
const building_blocks_ui_typography_1 = __webpack_require__(29829);
exports.FooterWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  box-sizing: border-box;
  border-top: 1px solid #e6eaf0;
`;
exports.MainContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  box-sizing: border-box;
  padding: ${(props) => props.isDesktop ? '55px 40px 0px 40px' : '35px 20px 0px 20px'};
  margin: auto;
  max-width: 1170px;
  width: 100%;
`;
exports.FooterMainContentWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  padding: 30px 0px;
  ${(props) => (props.noWrap ? '' : 'flex-wrap: wrap')}
`;
exports.FooterUlTag = building_blocks_ui_common_1.styled.ul `
  list-style-type: none;
  margin: 0 0 28px 0;
  padding: 0;
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
  margin: ${(props) => (props.isVisible ? '0 10px 10px 0' : 0)};
`;
// ${AnimateFadeIn}
exports.FooterLiTag = building_blocks_ui_common_1.styled.li `
  margin: 0 0 12px 0;

  &:first-child {
    margin-top: 10px;
  }
`;
exports.FooterAnchorTag = building_blocks_ui_common_1.styled.a `
  color: #151619;
  font-size: ${building_blocks_ui_common_1.$fontSize.xs};
  line-height: 20px;
  text-decoration: none;

  &:hover {
    color: #5b5675;
    cursor: pointer;
  }
`;
exports.FooterItemWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: column;
  flex-basis: 25%;
  ${(props) => (props.isDesktop ? 'margin-top: 15px;' : '')}
`;
exports.FooterItemTitle = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.H4) `
  font-size: ${building_blocks_ui_common_1.$fontSize.normal};
  font-weight: ${building_blocks_ui_common_1.$fontWeightBold};
  line-height: 22px;
  ${(props) => (props.isDesktop ? 'margin-bottom: 10px;' : '')}
  ${(props) => !props.isDesktop
    ? 'display: flex; flex-direction: row; justify-content: space-between; cursor: pointer;padding: 10px 0;'
    : ''}
    & > span {
    ${(props) => (props.isDesktop ? 'display: none' : '')}
  }
`;
exports.FooterTitleChevronOpen = `
  height: 24px;
  transform: scaleY(1);
`;
exports.FooterTitleChevronClosed = `
  height: 24px;
  transform: scaleY(-1);
`;
exports.FooterRow = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: row;
  ${(props) => (props.noWrap ? '' : 'flex-wrap: wrap')}
  ${(props) => (props.needSeparator ? 'border-bottom: 1px solid #E7E7F0' : '')}
`;
exports.FooterColumn = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: column;
`;
exports.FooterItem = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  flex-basis: ${(props) => (props.flexBasis ? props.flexBasis : '100%')};
  ${(props) => props.needBorderSpacing
    ? 'padding-bottom: 20px; border-top: 1px solid #e6eaf0;'
    : ''}
`;
exports.AckoInfoWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  padding: 15px 0px;
`;
exports.Heading = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.H4) `
  font-size: ${building_blocks_ui_common_1.$fontSize.normal};
  font-weight: ${building_blocks_ui_common_1.$fontWeightBold};
`;
exports.HeadingItem = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: ${building_blocks_ui_common_1.$fontSize.xs};
  font-weight: ${building_blocks_ui_common_1.$fontWeightLight};
  color: #5b5675;
  max-width: 470px;
  line-height: 18px;
  width: 100%;
  margin-top: 10px;
`;
exports.FooterSocialA = building_blocks_ui_common_1.styled.a `
  margin: 0 6px 10px 0;
`;
exports.StoreImageLink = building_blocks_ui_common_1.styled.img `
  height: inherit;
  display: inline-block;
  width: 80px;
`;
exports.AppStoreContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  margin-top: 15px;
`;
exports.GooglePlayLink = building_blocks_ui_common_1.styled.a `
  display: inline-block;
  margin: 0 10px 0 0;
`;
exports.AppleStoreLink = building_blocks_ui_common_1.styled.a `
  display: inline-block;
  margin: 0 10px 0 0;
`;
exports.DownloadHeading = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: ${building_blocks_ui_common_1.$fontSize.normal};
  font-weight: ${building_blocks_ui_common_1.$fontWeightBold};
`;
exports.DownloadContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  background: #efe9fb;
  border-radius: 12px;
  text-align: center;
  padding: 16px 0px;
  margin-top: 15px;
  margin-bottom: 42px;
  ${(props) => (props.isDesktop ? '' : 'width: 380px;')}
  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: 0;
  }
`;
exports.BottomWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  box-sizing: border-box;
  background: #f6f7fb;
`;
exports.BottomContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  box-sizing: border-box;
  flex-direction: ${(props) => (props.isDesktop ? 'row' : 'column')};
  padding:  ${(props) => (props.isDesktop ? '14px 35px;' : '14px 20px;')}
  margin: auto;
  max-width: 1170px;
  width: 100%;
  ${(props) => ((props === null || props === void 0 ? void 0 : props.gap) ? `gap: ${props === null || props === void 0 ? void 0 : props.gap}px` : 'gap: 0')}
`;
exports.BottomLink = building_blocks_ui_common_1.styled.a `
  line-height: 23px;
  color: #000;
  margin: 0 32px 0 0;
  text-decoration: none;
  font-size: ${building_blocks_ui_common_1.$fontSize.xxs};
  font-weight: ${building_blocks_ui_common_1.$fontWeightNormal};
`;
exports.BottomLabel = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  line-height: 23px;
  color: #000;
  margin: 0 32px 0 0;
  font-size: ${building_blocks_ui_common_1.$fontSize.xxs};
  font-weight: ${building_blocks_ui_common_1.$fontWeightNormal};
`;
exports.BottomLabelSecondary = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  color: #5b5675;
  font-size: ${building_blocks_ui_common_1.$fontSize.xxs};
  font-weight: 400;
  line-height: 16px;
  width: 100%;
  margin-bottom: ${(props) => props.isLpv2 ? '10px' : props.isLineBreak ? '24px' : 0};
  &:first-child {
    margin-top: 8px;
  }
`;
exports.Image = building_blocks_ui_common_1.styled.img `
  padding: ${(props) => (props.isDesktop ? '0 22px' : '')}
  height: ${(props) => (props.height ? props.height : 'auto')};
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '380px')}
`;
exports.GroupCompanies = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: column;
`;
exports.GroupCompanyHeading = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  color: #151619;
  margin: 0;
  font-size: 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 10px;
`;
exports.GroupCompanyUlTag = building_blocks_ui_common_1.styled.ul `
  list-style-type: none;
  margin: 0 0 28px 0;
  padding: 0;
  display: block;
  margin: 0 10px 10px 0;
`;
exports.GroupCompanyLiTag = building_blocks_ui_common_1.styled.li `
  margin: 0 0 12px 0;

  &:first-child {
    margin-top: 10px;
  }
`;
exports.GroupCompanyAnchorTag = building_blocks_ui_common_1.styled.a `
  color: #151619;
  font-size: ${building_blocks_ui_common_1.$fontSize.xs};
  line-height: 20px;
  text-decoration: none;

  &:hover {
    color: #5b5675;
    cursor: pointer;
  }
`;
//# sourceMappingURL=footer.styles.js.map

/***/ }),

/***/ 24621:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Youtube = exports.Twitter = exports.Linkedin = exports.Instagram = exports.Facebook = exports.ChevronIcon = exports.AppStore = exports.GooglePlay = exports.AckoCompanyLogo = void 0;
exports.AckoCompanyLogo = 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg';
exports.GooglePlay = 'https://acko-seo-prod.ackoassets.com/_next_static/images/google-play-footer.svg';
exports.AppStore = 'https://acko-seo-prod.ackoassets.com/_next_static/images/app-store-footer.svg';
exports.ChevronIcon = 'https://acko-seo-prod.ackoassets.com/_next_static/images/chevron-icon-footer.svg';
exports.Facebook = 'https://acko-seo-prod.ackoassets.com/_next_static/images/facebook-icon-footer.svg';
exports.Instagram = 'https://acko-seo-prod.ackoassets.com/_next_static/images/instagram-icon-footer.svg';
exports.Linkedin = 'https://acko-seo-prod.ackoassets.com/_next_static/images/linkedin-icon-footer.svg';
exports.Twitter = 'https://acko-seo-prod.ackoassets.com/_next_static/images/twitter-icon-footer.svg';
exports.Youtube = 'https://acko-seo-prod.ackoassets.com/_next_static/images/youtube-icon-footer.svg';
//# sourceMappingURL=footerIcons.js.map

/***/ }),

/***/ 511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.KJ = __webpack_unused_export__ = void 0;
const footer_1 = __webpack_require__(55831);
const list_Footer_links_1 = __webpack_require__(28297);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return list_Footer_links_1.FooterData; } });
Object.defineProperty(exports, "KJ", ({ enumerable: true, get: function () { return list_Footer_links_1.FooterDataGI; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return list_Footer_links_1.FooterDataLife; } });
exports.ZP = footer_1.Footer;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 71032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = useOnScreen;
const react_1 = __webpack_require__(11720);
function useOnScreen(ref) {
    const [isIntersecting, setIntersecting] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const observer = new window.IntersectionObserver(([entry]) => {
            setIntersecting(entry.isIntersecting);
        });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return isIntersecting;
}
//# sourceMappingURL=useOnScreen.js.map

/***/ }),

/***/ 5165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16219);

/***/ }),

/***/ 83198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);
var settle = __webpack_require__(88343);
var cookies = __webpack_require__(5390);
var buildURL = __webpack_require__(14249);
var buildFullPath = __webpack_require__(51000);
var parseHeaders = __webpack_require__(62031);
var isURLSameOrigin = __webpack_require__(55210);
var transitionalDefaults = __webpack_require__(85021);
var AxiosError = __webpack_require__(94783);
var CanceledError = __webpack_require__(27907);
var parseProtocol = __webpack_require__(39448);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 16219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);
var bind = __webpack_require__(79506);
var Axios = __webpack_require__(90667);
var mergeConfig = __webpack_require__(28893);
var defaults = __webpack_require__(98637);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(27907);
axios.CancelToken = __webpack_require__(27294);
axios.isCancel = __webpack_require__(66349);
axios.VERSION = (__webpack_require__(47870).version);
axios.toFormData = __webpack_require__(38931);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(94783);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(24870);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(55962);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 27294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(27907);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 27907:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(94783);
var utils = __webpack_require__(52712);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 66349:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 90667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);
var buildURL = __webpack_require__(14249);
var InterceptorManager = __webpack_require__(83293);
var dispatchRequest = __webpack_require__(9600);
var mergeConfig = __webpack_require__(28893);
var buildFullPath = __webpack_require__(51000);
var validator = __webpack_require__(95707);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 94783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 83293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 51000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(85558);
var combineURLs = __webpack_require__(12456);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 9600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);
var transformData = __webpack_require__(26255);
var isCancel = __webpack_require__(66349);
var defaults = __webpack_require__(98637);
var CanceledError = __webpack_require__(27907);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 28893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 88343:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(94783);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 26255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);
var defaults = __webpack_require__(98637);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 98637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(52712);
var normalizeHeaderName = __webpack_require__(81604);
var AxiosError = __webpack_require__(94783);
var transitionalDefaults = __webpack_require__(85021);
var toFormData = __webpack_require__(38931);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(83198);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(83198);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(96466)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 85021:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 47870:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 79506:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 14249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 12456:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 5390:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 85558:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 55962:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 55210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 81604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 96466:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 62031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52712);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 39448:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 24870:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 38931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];


var utils = __webpack_require__(52712);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 95707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(47870).version);
var AxiosError = __webpack_require__(94783);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 52712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(79506);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(11720));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(11720));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(11720));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(61688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(11720);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ })

}]);